var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 
 * @file Component for Activity feed
 */

import * as React from 'react';
import getProp from 'lodash/get';
import noop from 'lodash/noop';
import classNames from 'classnames';
import ActiveState from './ActiveState';
import ApprovalCommentForm from '../approval-comment-form';
import EmptyState from './EmptyState';
import { collapseFeedState, shouldShowEmptyState } from './activityFeedUtils';

var ActivityFeed = function (_React$Component) {
    _inherits(ActivityFeed, _React$Component);

    function ActivityFeed() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ActivityFeed);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityFeed.__proto__ || Object.getPrototypeOf(ActivityFeed)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isInputOpen: false
        }, _this.onKeyDown = function (event) {
            var nativeEvent = event.nativeEvent;

            nativeEvent.stopImmediatePropagation();
        }, _this.approvalCommentFormFocusHandler = function () {
            return _this.setState({ isInputOpen: true });
        }, _this.approvalCommentFormCancelHandler = function () {
            return _this.setState({ isInputOpen: false });
        }, _this.approvalCommentFormSubmitHandler = function () {
            return _this.setState({ isInputOpen: false });
        }, _this.onCommentCreate = function (_ref2) {
            var text = _ref2.text,
                hasMention = _ref2.hasMention;
            var _this$props$onComment = _this.props.onCommentCreate,
                onCommentCreate = _this$props$onComment === undefined ? noop : _this$props$onComment;

            onCommentCreate(text, hasMention);
            _this.approvalCommentFormSubmitHandler();
        }, _this.onTaskCreate = function (_ref3) {
            var text = _ref3.text,
                assignees = _ref3.assignees,
                dueAt = _ref3.dueAt;
            var _this$props$onTaskCre = _this.props.onTaskCreate,
                onTaskCreate = _this$props$onTaskCre === undefined ? noop : _this$props$onTaskCre;

            onTaskCreate(text, assignees, dueAt);
            _this.approvalCommentFormSubmitHandler();
        }, _this.openVersionHistoryPopup = function (data) {
            var versionInfoHandler = _this.props.onVersionHistoryClick || noop;
            versionInfoHandler(data);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /**
     * Creates a task.
     *
     * @param {string} text - Task text
     * @param {Array} assignees - List of assignees
     * @param {number} dueAt - Task's due date
     * @return {void}
     */


    /**
     * Invokes version history popup handler.
     *
     * @param {Object} data - Version history data
     * @return {void}
     */


    _createClass(ActivityFeed, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                translations = _props.translations,
                approverSelectorContacts = _props.approverSelectorContacts,
                mentionSelectorContacts = _props.mentionSelectorContacts,
                currentUser = _props.currentUser,
                isDisabled = _props.isDisabled,
                getAvatarUrl = _props.getAvatarUrl,
                getUserProfileUrl = _props.getUserProfileUrl,
                file = _props.file,
                onCommentCreate = _props.onCommentCreate,
                getApproverWithQuery = _props.getApproverWithQuery,
                getMentionWithQuery = _props.getMentionWithQuery,
                activityFeedError = _props.activityFeedError,
                onVersionHistoryClick = _props.onVersionHistoryClick,
                onCommentDelete = _props.onCommentDelete,
                onTaskDelete = _props.onTaskDelete,
                onTaskUpdate = _props.onTaskUpdate,
                onTaskAssignmentUpdate = _props.onTaskAssignmentUpdate,
                feedItems = _props.feedItems;
            var isInputOpen = this.state.isInputOpen;

            var hasCommentPermission = getProp(file, 'permissions.can_comment', false);
            var showApprovalCommentForm = !!(currentUser && hasCommentPermission && onCommentCreate && feedItems);

            return (
                // eslint-disable-next-line
                React.createElement(
                    'div',
                    { className: 'bcs-activity-feed', onKeyDown: this.onKeyDown },
                    React.createElement(
                        'div',
                        {
                            ref: function ref(_ref4) {
                                _this2.feedContainer = _ref4;
                            },
                            className: 'bcs-activity-feed-items-container'
                        },
                        shouldShowEmptyState(feedItems) || !currentUser ? React.createElement(EmptyState, {
                            isLoading: !feedItems,
                            showCommentMessage: showApprovalCommentForm
                        }) : React.createElement(ActiveState, _extends({}, activityFeedError, {
                            items: collapseFeedState(feedItems),
                            isDisabled: isDisabled,
                            currentUser: currentUser,
                            onTaskAssignmentUpdate: onTaskAssignmentUpdate,
                            onCommentDelete: hasCommentPermission ? onCommentDelete : noop
                            // We don't know task edit/delete specific permissions,
                            // but you must at least be able to comment to do these operations.
                            , onTaskDelete: hasCommentPermission ? onTaskDelete : noop,
                            onTaskEdit: hasCommentPermission ? onTaskUpdate : noop,
                            onVersionInfo: onVersionHistoryClick ? this.openVersionHistoryPopup : null,
                            translations: translations,
                            getAvatarUrl: getAvatarUrl,
                            getUserProfileUrl: getUserProfileUrl,
                            mentionSelectorContacts: mentionSelectorContacts,
                            getMentionWithQuery: getMentionWithQuery
                        }))
                    ),
                    showApprovalCommentForm ? React.createElement(ApprovalCommentForm, {
                        onSubmit: function onSubmit() {
                            if (_this2.feedContainer) {
                                _this2.feedContainer.scrollTop = 0;
                            }
                        },
                        isDisabled: isDisabled,
                        approverSelectorContacts: approverSelectorContacts,
                        mentionSelectorContacts: mentionSelectorContacts,
                        className: classNames('bcs-activity-feed-comment-input', {
                            'bcs-is-disabled': isDisabled
                        }),
                        createComment: hasCommentPermission ? this.onCommentCreate : noop,
                        createTask: hasCommentPermission ? this.onTaskCreate : noop,
                        updateTask: hasCommentPermission ? onTaskUpdate : noop,
                        getApproverWithQuery: getApproverWithQuery,
                        getMentionWithQuery: getMentionWithQuery,
                        isOpen: isInputOpen,
                        user: currentUser,
                        onCancel: this.approvalCommentFormCancelHandler,
                        onFocus: this.approvalCommentFormFocusHandler,
                        getAvatarUrl: getAvatarUrl
                    }) : null
                )
            );
        }
    }]);

    return ActivityFeed;
}(React.Component);

export default ActivityFeed;